export * from '../../state/feedback/selectors';



/** WEBPACK FOOTER **
 ** ./src/members/__shared__/selectors/feedback.js
 **/